module.exports = __webpack_public_path__ + "static/img/shixuncode.31b7fee.png";


//////////////////
// WEBPACK FOOTER
// ./static/shixuncode.png
// module id = /YRD
// module chunks = 1